import React, { useState } from "react";

import './payemntSwitcher.scss';
import {PaymentType} from "../../../constants/paymentTypes";

const PaymentTypeBlock = ({paymentType, selectPaymentType, currentPaymentType }) => {

  return (
    <div
      className={`payment-type ${paymentType.payment_code.toLowerCase()} ${currentPaymentType && currentPaymentType.payment_code === paymentType.payment_code ? 'active' : ''}`}
      onClick={ ()=> { selectPaymentType(paymentType) }}
    >
      <div className={'title'}>
        { paymentType.payment_type_name }
      </div>
    </div>
  );
};

export default PaymentTypeBlock;
